'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleRelatedCarousel = function ArticleRelatedCarousel(el) {
  (0, _classCallCheck3.default)(this, ArticleRelatedCarousel);

  var carousel = (0, _functional.getElement)('[data-module="article-related-carousel"]');
  var flkty = new _flickity2.default(carousel, {
    cellAlign: 'center',
    cellSelector: '.art-Related_Item',
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    watchCSS: true,
    touchVerticalScroll: false,
    dragThreshold: 30
  });

  flkty.on('dragStart.el', function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  flkty.on('dragEnd.flickity', function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });
};

exports.default = ArticleRelatedCarousel;